import Vue from 'vue'
import Vuex from 'vuex'
import applicationState from './store/modules/application.state'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    applicationState
  }
})
